import { FieldWidthEnum, NavigationCommandMetadata, NavigationCommandQuery } from 'src/cer/cer-data/cer-data-types';
import { VoucherPostingLogic } from './voucher-list/voucherposting-view.service';
import { CerFormAdapter } from '@cer/cer-form/cer-form-adapter';
import { CerFormView } from '@cer/cer-form/cer-form-view';

export class VoucherMessageMailVendorHistoryForm extends CerFormAdapter {
  
  public override view(): CerFormView {
    return new CerFormView({
      viewMetadata: {
        name: 'bilag-afsendere', dataApiName: 'VoucherMessageMailVendorHistory', text: 'Afsendere', textSingular: 'Afsender',
        primaryKey: 'id', titleFields: ['fromEmail', 'vendorNum'], baseFields: ['id', 'history'],
        onBeforeNavigations: (e => this.navigationsGet(e))
      },
      fieldMetadata: [
          { name: 'fromEmail', text: 'Afsender e-mail', tooltipText: 'Kreditor afsender e-mail adresse', required: true, allowEdit: true, allowEditOnAdd: true, widthType: FieldWidthEnum.L },
          { name: 'postingType', text: 'Posteringstype', tooltipText: 'Type af kontonummer', allowEdit: true, widthType: FieldWidthEnum.M, foreignKeyTableName: 'VoucherPostingType' },
          { name: 'accountNum', text: 'Kontonr.', tooltipText: 'Kontonummer på kreditor/finans mm', allowEdit: true, widthType: FieldWidthEnum.M },
          { name: 'accountName', text: 'Kontonavn', tooltipText: 'Navn på kontonummer', allowEdit: false, widthType: FieldWidthEnum.L, foreignKeyUsing: 'accountNum' },
          { name: 'useCount', text: 'Antal bilag', tooltipText: 'Antal bilag hvor kreditor e-mail er anvendt', defaultValue: 0, required: true, allowEdit: false, visibleAdd: false, visibleEdit: false, format: 'Number' },
          { name: 'isDefault', text: 'Standard', tooltipText: 'Brug altid som konteringskonto', defaultValue: 0, allowEdit: true, format: 'CheckBox' },
          { name: 'formRecognizer', text: 'Dokument genkendelse', tooltipText: 'Opsætning til automatisk dokument genkendelse', allowEdit: true, widthType: FieldWidthEnum.M, foreignKeyTableName: 'FormRecognizer', foreignKeyField: 'id', foreignKeyValue: 'name' },
          { name: 'voucherApprover', text: 'Godkender', tooltipText: 'Standard godkender for bilag', allowEdit: true, widthType: FieldWidthEnum.M, foreignKeyTableName: 'User', foreignKeyValue: 'shortName' }
        ]
    });
  }

  public navigationsGet(e: NavigationCommandQuery): NavigationCommandMetadata[] {
    switch (e.fieldMeta?.name) {
      case 'accountNum':
        return VoucherPostingLogic.postingTypeNavigationQuery(e.rowData?.postingType);
    }
    return null;
  }

}
